<div class="w-full bg-white">
  <yr-artist-profile></yr-artist-profile>
</div>
